import { Pipe, PipeTransform } from '@angular/core';

import { OrderStatusAction } from '../models/cutting/cutting-order-status.model';

@Pipe({
  name: 'defaultCuttingOrderStatusName',
})
export class DefaultCuttingOrderStatusNamePipe implements PipeTransform {
  transform(value: OrderStatusAction): string {
    switch (value) {
      case OrderStatusAction.Create:
        return $localize`Черновик`;

      case OrderStatusAction.CuttingCompleted:
        return $localize`Черновик (Раскроен)`;

      case OrderStatusAction.Ordering:
        return $localize`Проверяется администратором`;

      case OrderStatusAction.Verified:
        return $localize`Проверен администратором`;

      case OrderStatusAction.Completed:
        return $localize`Выполнен`;

      case OrderStatusAction.Confirm:
        return $localize`Принят`;

      case OrderStatusAction.Paid:
        return $localize`Оплачен`;

      default:
        return '';
    }
  }
}
